module.exports = __webpack_public_path__ + "video-play.svg?9b737958b1644b46b23904e53afcac50";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/video-play.svg
// module id = 39
// module chunks = 0